// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__98lL8","Success":"Button_Success__3GmxT","Danger":"Button_Danger__1usfg","StickToBottom":"Button_StickToBottom__2DX00"};